import React, { lazy } from 'react';
import IconDropframe from '@/assets/images/menu/icon-dropframe.react.svg?react';
import { AuthNodes } from '@/config/app/auth';
import { MultiApp } from '@/config/context';
import { getProductId, isFlutter } from '@/infrastructure/product-info';
import { CapitalPlatform } from '@/infrastructure/utils/app';

import { MenuIcon } from '@/presentation/components/menu-icon';
import { IRouteConfig } from '../types';

const FLUTTER_DROP_FRAME_ISSUE_LIST_PRODUCT_ID = 'afc8f82b01';
const shouldShowDropFrameIssueList = () => !isFlutter() || getProductId() === FLUTTER_DROP_FRAME_ISSUE_LIST_PRODUCT_ID;

export const dropFrameRoutes = (): IRouteConfig[] => [
  {
    path: '/drop-frame',
    name: '卡顿',
    icon: <MenuIcon icon={IconDropframe} fontSize={16} />,
    sort: 94,
    authName: AuthNodes.DropFrame,
    platforms: [
      CapitalPlatform.Android,
      CapitalPlatform.IOS,
      CapitalPlatform.Mac,
      CapitalPlatform.Windows,
      CapitalPlatform.VisionOS,
      CapitalPlatform.Flutter,
      CapitalPlatform.HarmonyOS,
      CapitalPlatform.AppleTV,
    ],
    disabledByFree: true,
    routes: [
      {
        path: '/drop-frame/analytics',
        name: '指标分析',
        component: lazy(() => import('@/presentation/pages/drop-frame/analytics')),
      },
      {
        path: '/drop-frame/analytics-old',
        name: '指标分析',
        component: lazy(() => import('@/presentation/pages/drop-frame/analytics')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/drop-frame/issues/list',
        name: '问题列表',
        component: lazy(() => import('@/presentation/pages/drop-frame/issues/list')),
        validator: shouldShowDropFrameIssueList,
      },
      {
        path: '/drop-frame/issues/detail',
        name: '问题详情',
        component: lazy(() => import('@/presentation/pages/drop-frame/issues/detail')),
        hideInMenu: true,
        whitelisted: true,
        // excludePlatforms: [
        //   CapitalPlatform.Flutter,
        // ],
      },
      {
        path: '/drop-frame/multi-hotspot/list',
        name: '多点归因',
        versions: [MultiApp.WOA],
        component: lazy(() => import('@/presentation/pages/drop-frame/multi-hotspot/list')),
      },
      {
        path: '/drop-frame/multi-hotspot/detail',
        name: '多点归因详情',
        versions: [MultiApp.WOA],
        component: lazy(() => import('@/presentation/pages/drop-frame/multi-hotspot/detail')),
        hideInMenu: true,
        whitelisted: true,
      },
      {
        path: '/drop-frame/tree',
        name: '卡顿树',
        component: lazy(() => import('@/presentation/pages/drop-frame/tree')),
        platforms: [
          CapitalPlatform.Android,
          CapitalPlatform.IOS,
          CapitalPlatform.Mac,
          CapitalPlatform.Windows,
          CapitalPlatform.VisionOS,
          CapitalPlatform.AppleTV,
        ],
      },
      {
        path: '/drop-frame/task-detail',
        name: '离线任务详情',
        component: lazy(() => import('@/presentation/pages/drop-frame/tree/task-detail')),
        hideInMenu: true,
      },
    ],
  },
];

export default dropFrameRoutes;
